import { useQuery } from '@apollo/client/react/hooks/useQuery';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useContext } from 'react';
import { Query } from '../../typings/graphql';
import { CHANGE_CATEGORY_ACTION, ItemFilterContext } from '.';
import { gql } from '@apollo/client/core';

const CATEGORIES_QUERY = gql`
	query categories {
		itemCategories {
			id
			name
		}
	}
`;

const FilterCategorySelect = (): JSX.Element | null => {
	const { state, dispatch } = useContext(ItemFilterContext);

	const { data } = useQuery<Pick<Query, 'itemCategories'>>(CATEGORIES_QUERY);

	if (!data?.itemCategories) return null;

	const sorted = data.itemCategories
		.slice(0)
		.sort((a, b) => a.name!.localeCompare(b.name!));

	return (
		<FormControl variant="outlined" fullWidth>
			<InputLabel id="filter-by-category">Category</InputLabel>
			<Select
				labelId="filter-by-category"
				id="filter-by-category-select"
				value={state.category}
				onChange={(event): void =>
					dispatch({
						type: CHANGE_CATEGORY_ACTION,
						payload: event.target.value,
					})
				}
				labelWidth={102}
				name="category"
				fullWidth
			>
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
				{sorted.map((el) => (
					<MenuItem key={el.id} value={el.id}>
						{el.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default FilterCategorySelect;
